module.exports = require("punycode");


//////////////////
// WEBPACK FOOTER
// external "punycode"
// module id = 308
// module chunks = 0 1 3